import React, { useMemo } from "react";
import MaterialIcon from "../../../../shared/components/MaterialIcon";
import { useTranslation, getHubViews } from "../../../../i18n";

function tabClasses(view, active) {
  if (view.danger) {
    return active
      ? [
          "border-error bg-error text-on-error",
          "shadow-[0_4px_18px_rgba(186,26,26,0.35)] ring-2 ring-error/25",
        ].join(" ")
      : [
          "border-error/45 bg-error-container/25 text-error",
          "hover:border-error hover:bg-error-container/45",
          "shadow-[0_2px_10px_rgba(186,26,26,0.12)]",
        ].join(" ");
  }

  return active
    ? "border-primary bg-primary text-on-primary shadow-sm"
    : "border-outline-variant bg-surface-container-lowest text-on-surface-variant hover:border-outline hover:bg-surface-container-low";
}

function countBadgeClasses(view, active) {
  if (view.danger) {
    return active
      ? "bg-on-error/20 text-on-error"
      : "bg-error/15 text-error";
  }

  return active
    ? "bg-on-primary/15 text-on-primary"
    : "bg-surface-container-high text-on-surface-variant";
}

const ReviewHubViewTabs = ({ activeView, onChange, counts = {} }) => {
  const { t } = useTranslation();
  const hubViews = useMemo(() => getHubViews(t), [t]);

  return (
    <div className="flex flex-wrap gap-2">
      {hubViews.map((view) => {
        const active = activeView === view.id;
        const count = counts[view.id];

        return (
          <button
            key={view.id}
            type="button"
            onClick={() => onChange(view.id)}
            className={[
              "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-label-sm font-medium transition-all",
              tabClasses(view, active),
            ].join(" ")}
          >
            <MaterialIcon
              name={view.icon}
              className={`text-[16px] ${view.danger && !active ? "text-error" : ""}`}
            />
            {view.label}
            {typeof count === "number" ? (
              <span
                className={[
                  "rounded-full px-2 py-0.5 text-[11px] font-semibold tabular-nums",
                  countBadgeClasses(view, active),
                ].join(" ")}
              >
                {count}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
};

export default ReviewHubViewTabs;
